<template lang="pug">
v-container(fluid data-test="cm-page")
  portal(to='toolbar') 
    v-toolbar-title Cursussen

  CMChips(:active-courses="activeCourses" @delete="onDeleteCourseDate")
  v-card
    .d-flex.cm
      CMSidebar(
        :key="$route.query.city" 
        @mounted="clearActive"
        @coursesLoaded="saveCourses" 
        @click:course="loadListProcess"
        ref="sidebar"
      )

      CMBody(
        ref="CMbody"
        :key="$route.query.course_id + 'body'"
        :list="list"
        :loading="loading"
        :candidatesCount="candidatesCount"
        :primaryPagination="primaryPagination"
        :pagination="pagination"
        :groupedList="groupedList"
        @change:ordering="_loadList"
        @change:query="_loadList"
        @selectAllToggle="toggleSelectAllItems"
        @needToUpdate:courses="loadCourses"
      )
        template(v-slot:footer="footerOptions")
          .pagination(v-if="pagination")
            div.pagination__more
              v-btn(color="primary" 
              text 
              class="mb-3 mt-3" 
              data-test="candidate-loadmore" 
              @click="onLoadMoreClick" 
              :loading="loading" 
              v-if="pagination.next"
            ) load more
            div.pagination__actions
              per-page-select(@change="onPageSizeChanged")
              v-pagination(
                @input="paginationChange"
                :disabled="loading"
                :length="pagination.totalPages" 
                v-model="pagination.page" 
                :total-visible="8"
              )
      location-config(
        :key="`${$route.query.city}/${$route.query.course_id || -1}`" 
        v-if="activeCourses && activeCourses.length"
        :list="courseConfigurations"
        @mounted="loadCourseConfiguration(activeCourse.id)"
      )
    
  log
    template(v-slot:action="log")
      span
        v-btn( 
          color="primary" fab @click="log.loadLogs" data-test="log-btn" 
        ).btn-floating
          v-icon(color="white") mdi-post
</template>

<script>
import {mapGetters, mapActions, mapMutations, mapState} from "vuex"

import errorsMixin from '@/mixins/errors.mixin'
import Svc from "./core/cm-service"
import CandidatesService from "@/app/admin/modules/candidates/core/candidates-service"
import { CANDIDATE_PAGE } from '../candidates/core/candidates-const'
import CandidatesLog from "@/app/admin/modules/candidates/components/CandidatesLog.vue"
import CandidatesCount from "@/app/admin/modules/candidates/core/models/candidatesCountModel"
import CandidateBroadcast from "@/app/admin/modules/candidates/core/models/candidateBroadcast"
import paginationMixin from '@/mixins/pagination.mixin'
import PaginationModel from '../../../../models/paginationModel'
import Logs from "@/app/admin/components/Log.vue"
import CandidateLogModel from "@/app/admin/modules/candidates/core/models/candidatesLogModel"
import { LOG_PAGE } from '../../../../util/const'
import CMLocationConfigModel from "./classes/CMLocationConfigModel"
import CurssList from "./classes/curssussen/CMCurssList"

export default {
  mixins: [errorsMixin, paginationMixin],

  data: () => ({
    candidatesSvc: new CandidatesService(),
    loading: false,
    list: [],
    groupedList: {},
    fullListIds: [],
    svc: new Svc(),
    courses: null,
    candidatesCount: new CandidatesCount(),
    pagination: null,
    primaryPagination: null,
    logs: null,
    logsShowing: false,
    logActive: true,
    activeCourse: null,
    courseConfigurations: []
  }),

  created() {
    if(!this.$route.query.city) {
      this.$router.replace({query: {city: 4}})
    }
    //    await this.setDefaultPagination()
    this.initCandidateBroadcast()
  },

  computed: {
    ...mapState('cm', {
      activeCourses: state => state.activeCourses
    }),
    ...mapGetters({
      currentUser: 'user/current',
    })
  },

  mounted() {
    this.loadCBRUser({cache: true})
    this.loadCandidateColors()
  },

  methods: {
    async onPageSizeChanged(size) {
      await this.updatePageSize(size);
      this._loadList({})
    },
    ...mapActions({
      loadCBRUser: 'cbrUser/list',
      loadCandidateColors: 'crmCandidateColors/colorsList',
    }),
    ...mapMutations({
      unSelectCourse: 'cm/unSelectCourse',
      unSelectAllCourses: 'cm/unSelectAllCourses',
    }),
    saveCourses(courses) {
      this.courses = courses
      this.list = []
    },

    loadListProcess() {
      if (this.activeCourses.length) {
        this._loadList({})
      } else {
        this.clearList()
      }
    },

    async loadList() {
      try {
        this.loading = true
        let page = this.$route.query.page_name ? this.$route.query.page_name : CANDIDATE_PAGE.RESERVED_ALL_WILL_COME
        let res = await this.candidatesSvc.list({...this.$route.query }, page)
        this.list = res.results
        this.candidatesCount.set(res.candidates_counts)
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
      finally {
        this.loading = false
      }
    },

    async loadCourseConfiguration(courseID) {
      try {
        this.loading = true
        let configurations = await this.svc.getCourseConfiguration(courseID)
        this.courseConfigurations = configurations.map(item => new CMLocationConfigModel(item))
      } catch (error) {
        console.log(error)
      }
      finally {
        this.loading = false
      }
    },


    async onDeleteCourseDate(data) {
      this.unSelectCourse(data)
      await this.$refs.sidebar.setDateQuery()
      if (this.activeCourses.length) {
        this._loadList()
      } else {
        this.clearList()
      }
    },

    clearActive() {
      this.unSelectAllCourses()
    },

    clearList() {
      this.candidatesCount = new CandidatesCount()
      this.clearGroupedList()
    },

    async _loadList(item = {more: false}) {
      try {
        this.clearList()
        let page = this.$route.query.page_name ? this.$route.query.page_name : CANDIDATE_PAGE.RESERVED_ALL_WILL_COME
        this.loading = true
        let { results, pagination, candidates_counts} = await this.candidatesSvc.list({
          ...this.$route.query,
          ordering: ['exam_location', 'exam_datetime'],
          size: 500
        }, page)
        this.pagination = new PaginationModel(this.setPaginationParams(pagination))
        let groupedList  = new CurssList(results).getList()
        
        this.groupedList = groupedList
        

        this.candidatesCount.set(candidates_counts)
        if(item.more) this.list.push(...results)
        else {
          this.list = results
          this.setPrimaryPagination()
        } 
        this.clearFullListIds();
        this.loading = false
        this.$emit('candidatesCountsChanged', candidates_counts)
        
      } catch (error) {
        console.log(error)
        this.loading = false
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    },

    clearGroupedList() {
      for(let group in this.groupedList) {
        this.$delete(this.groupedList, group)
      }
    },

    setGroupedList(groupedList) {
      for(let group in groupedList) {
        this.$set(this.groupedList, group, groupedList[group])
      }
    },

    async toggleSelectAllItems(clear) {
      if (clear) {
        this.$refs.CMbody.setActiveItems([]);
      } else {
        if (!this.fullListIds.length) {
          await this._loadList()
          await this._getFullListIds();
        }
        this.$refs.CMbody.setActiveItems(this.fullListIds);
      }
    },

    async _getFullListIds() {
      const page = this.$route.query.page_name ? this.$route.query.page_name : CANDIDATE_PAGE.RESERVED_ALL
      if (this.pagination.count > this.pagination.size) {
        try {
          const res = await this.candidatesSvc.fullListIds(
            {
              ids_list: true,
              ...this.$route.query
            },
            page
          )
          this.fullListIds = res;
        } catch (error) {
          console.log(error)
          this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
        }     
      } else {
        this.fullListIds = [];
      }
    },

    setPrimaryPagination() {
      this.primaryPagination = {
        page: this.pagination.page,
        size: this.pagination.size
      }
    },

    async paginationChange() {
      await this.setPaginationQuery()
      this._loadList({})
    },

    async onLoadMoreClick() {
      this.pagination.loadMore()
      await this.setPaginationQuery()
      this._loadList({more: true})
    },

    async initCandidateBroadcast() {
      let tokens
      tokens = await this.$auth.getTokensFromRepoOrRefresh()
      this.broadcast = new CandidateBroadcast(null, tokens.access)
      this.broadcast.startListen(this.getBroadcastData)
    },

    getBroadcastData() {
      return this.list
    },

    loadCourses() {
      this.$refs.sidebar.loadData()
    },

    clearFullListIds() {
      this.fullListIds = [];
    },
  },

  beforeRouteLeave(to, from, next) {
    this.$store.commit('cm/clearAll')
    next()
  },

  provide: function() {
    return {
      svc: this.svc,
      candidatesSvc: this.candidatesSvc,
      getDefaultPagination: this.getDefaultPagination,
    }
  },

  components: {
    CMSidebar: () => import('./components/curssusen/CMCurssSidebarSelector.vue'),
    CMBody: () => import('./components/CMBody.vue'),
    locationConfig: () => import('./components/curssusen/CMLocationConfig.vue'),
    CMChips: () => import('./components/CMChips.vue'),
    perPageSelect: () => import('@/app/admin/components/PerPageSelect.vue'),
    logsTabs: () => import ('@/app/admin/modules/candidates/components/candidates/CandidatesLogTabs.vue'),
    logs: Logs,
    log: CandidatesLog
  },

  watch: {
    '$route.query.city'() {
      this.candidatesCount = new CandidatesCount()
      this.pagination = null
      this.activeCourse = null
      this.clearList()
    },

  }
}
</script>

<style lang="scss">

.pagination{
  position: relative;
}

.cm-header-cell {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  height: 64px;
  border-bottom: 1px solid $border-color;
}

.cm-spacing {
  padding-left: 24px;
  padding-right: 16px;
}

.cm {
  & > div {
    border-right: 1px solid $border-color;
    &:last-child {
      border-right: unset;
    }
  }
}

.cm-area {
  height: calc(100vh - 135px);
  overflow-y: auto;
}

</style>
